import { getCurvedRows } from './utils';
export const useCurvedMultiRow = ({ definition, rows: passedRows }) => {
    if (passedRows) {
        return { rows: passedRows };
    }
    const rows = getCurvedRows({ definition });
    return { rows };
};
//# sourceMappingURL=use-curved-multi-row.js.map